import { render } from "./HelloWorld.vue?vue&type=template&id=ccd7d7c0"
import script from "./HelloWorld.vue?vue&type=script&lang=js"
export * from "./HelloWorld.vue?vue&type=script&lang=js"

import "./HelloWorld.vue?vue&type=style&index=0&id=ccd7d7c0&lang=css"

import exportComponent from "/root/hello-world/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__